// 按页面划分
export default {
    // 公共页面
    common: {
        title: "Centro comercial de datos",
        pull_refresh: 'Tira hacia abajo para actualizar',
        release_refresh: 'Suelte para actualizar',
        refresh_loading: 'Cargando…',
        footer_text: 'Servicios proporcionados por Ucloudlink (NASDAQ: UCL)'
    },
    home: {
        input_placeholder: 'Buscar país/región',
        my_flow: 'mis datos',
        charge_code: 'Código de cupón',
        coupons:'Cupones',
        local_package: 'Datos locales',
        more: 'Más',
        popular_destination: 'País/región',
        buy_now: 'Comprar ahora',
        package_useing: 'Activo',
        unused: 'Inactivo',
        download_app: 'Descargar APP',
        enter_the_mall_list: 'Ir al centro comercial',
        no_data: 'Sin datos',
        no_data_available: 'No hay datos disponibles',
        copy_success: 'Copiar con éxito',
        copy_fail: 'Error de copia',
        meritsTitle: '¿Cuáles son las ventajas?',
        merits1: 'Sin SIM necesario & Sin cuota mensual',
        merits2: 'Integrado con los 2-3 operadores líderes para cambio automático de red',
        go_buy: 'Comprar',
        instant_savings: 'Ahorrar',
        expires_in: 'Expira en',
        download_app_tips: "Descarga la app para más ofertas y experiencias"
    },
    packages: {
        sub_title: {
            us: 'Excluyendo Guam, Saipan',
            it: 'Incluyendo la Ciudad del Vaticano, San Marino',
            va: 'Incluyendo Italia, San Marino',
            sm: 'Incluyendo Italia, Ciudad del Vaticano',
            ma: 'Incluyendo el Sáhara Occidental',
            eh: 'Incluyendo Marruecos',
            ch: 'Incluyendo Liechtenstein',
            li: 'Incluyendo Suiza',
            fr: 'Incluyendo Mónaco',
            mc: 'Incluyendo Francia',
            fi: 'Incluyendo las Islas Aland',
            ax: 'Incluyendo Finlandia',
            gu: 'Incluyendo las Islas Marianas del Norte',
            mp: 'Incluyendo Guam'
        },
        unlimited_packages: 'Paquete de datos ilimitados',
        normal_packages: 'Paquete de datos normales',
        multi_region_packages: 'Multirregión',
        regional_data: 'Datos Regionales',
        high_speed_text: 'datos de alta velocidad',
        infiniteFlow: 'Datos ilimitados',
        unLimitData: 'Ilimitado',
        high_speed_text_year: 'alta velocidad/mp',
        package_list: 'Lista de paquetes',
        special_offer: 'Ofertas',
        first_month: '1er Mes',
        periodUnit: {
            day: 'días',
            month: 'mes',
            hour: 'horas',
            year: 'año',
        },
        periodUnits: {
            day: 'días',
            month: 'meses',
            hour: 'horas',
            year: 'años',
        },
        periodUnitSimp: {
            day: 'd',
            month: 'para',
            hour: 'h',
            year: 'el'
        },
        periodUnitMonthly:'Mensual',
        periodUnitsSimp: {
            day: 'd',
            month: 'para',
            hour: 'h',
            year: 'el'
        },
        unlimited_good_name: {
            day: 'Pase de un día',
            month: 'Pase mensual',
            year: 'Pase Anual'
        },
        continuousMonth: "Meses continuos",
        continuousDay: "Días continuos",
        continuousYear: "Años continuos",

        day_invalid: 'Caducar el día actual',
        month_invalid: 'Caducar en el mes actual',
        immediate_valid: 'Con efecto inmediato',
        tomorrow_day_valid: 'Efectivo a partir del día siguiente.',
        tomorrow_month_valid: 'En vigor a partir del próximo mes',

        detail: {
            cell_flow: 'Datos',
            cell_period: 'Validez',
            buy_quantity: 'Cantidad',
            use_area: 'Cobertura',
            use_intro: 'Términos y condiciones',
            buy_btn: 'Orden',
            pay: 'Pagar',
            buy_tips: 'Tienes el paquete %@packageName en uso. ¿Quieres comprar este paquete?',
            haveOrderTips: "Pedido pendiente de pago generado. Haz clic Confirmar para ir a mi página de datos！"
        },
        confirm: {
            title: 'Confirmación de pedido',
            real_pay_amount: 'Monto pagado',
            online_payment: 'Pago en línea',
            create_order_error: 'Error de configuración'
        }
    },
    pay: {
        result: {
            loading_order_status: 'Obteniendo el estado del pedido...',
            buy_success: 'Orden completa',
            buy_pending: 'Pendiente de confirmación',
            buy_pending_tip: 'Pago en proceso... Si el pago no se transfirió dentro de los 10 minutos, comuníquese con nosotros para obtener ayuda.',
            get_payment_info_fail: 'Falló la adquisición de información de pago',
            cell_package: 'Paquete',
            cell_buy_amount: 'Subtotal',
            cell_real_amount: 'Monto pagado',
            go_to_order_btn: 'Ir a mi paquete',
            back_home: 'Volver a Inicio',
            back_mall: 'Volver al centro comercial',
            ordersn_empty: 'El pedido SN no puede estar vacío',
            order_search_error: 'error inesperado',
            goodsName:"Nombre del producto"
        },
        fail: {
            payment_fail: 'Pago fallido',
            back_home: 'Volver a Inicio'
        }
    },
    CountryGroup: {
        title: "País/región",
        placeholder: "Buscar país o región",
        clear: "Claro",
        history: "Historial de búsqueda"
    },
    PromotionCode: {
        verification: {
          title: "Código de cupón",
          minititle: "Código de cupón",
          input: "Por favor introduce el código de recarga",
          explain: "Consejos: toque el botón de escaneo en la parte superior derecha para escanear el código QR de la tarjeta de cupón o ingrese manualmente el código de cupón (distingue entre mayúsculas y minúsculas) si no funciona.",
          submit: "Entregar",
          exchange: "Canjear",
          cancel: "Cancelar",
          Inquiry: "¿Estás seguro de intercambiar?",
          ErrorCode: "Error de código de recarga"
        },
        recharge_success: {
          package: "Paquete",
          content: "Canjeado con éxito",
          back: "Volver al centro comercial",
          view_packets: "Ir a mi paquete"
        }
      },
      order: {
        state: {
          inUse: "Activado",
          isFirst: "Priorizado",
          toFirst: "Establecer prioridad",
          inactive: "Inactivado" 
        },
        periodUnits: {
          minute: "minutos",
          hour: "horas",
          day: "días",
          month: "meses"
        },
        useIntro: {
          tip1: "El paquete de datos ilimitados tiene mayor prioridad que el paquete de datos por volumen；",
          tip2: "La prioridad de uso se basará en la fecha de compra para el mismo tipo de paquete, es decir, el paquete con la fecha de compra más temprana se consumirá primero, mientras que la prioridad de los paquetes de una sola región es mayor que la del paquete regional；",
          tip3: "También puede ajustar manualmente la prioridad de utilizar paquetes del mismo tipo。"
        },
        myFlow: "mis datos",
        remainingFlow: "Datos restantes",
        remainingTime: "Izquierda válida",
        remainingHighFlow: "Quedan datos de alta velocidad",
        validPeriod: "Validez",
        noneFlow: "Sin paquete de datos",
        noneFlowTip: "Adquiera el paquete de datos y disfrute de una red de alta calidad.",
        buyPackFlow: "Comprar paquetes",
        checkInvalidFlow: "Verifique el paquete de datos vencido",
        orderList:   {
          "title": "mis ordenes",
          "amount_paid": "Total",
          "device": "Dispositivo propio",
          "order_details": "Detalles del pedido",
          "total_amont": "Total parcial",
          "orderSN": "Nro. de pedido.",
          "createTime": "tiempo de creación",
          "cancelTime": "hora cerrada",
          "payTime": "hora del pedido",
          "unsubTime": "Hora cancelada",
          "payMethod": "Método de pago",
          "thirdSN": "Transacción no.",
          "delete": "Borrar",
          "cancel": "Cancelar pedido",
          "unsub": "Reembolso",
          "goto_cancel": "¿Quieres cancelar el pedido?",
          "goto_unsubscribe": "¿Quieres dar de baja el pedido?",
          "delete_Tips": "El pedido no se puede reanudar después de haber sido eliminado, por lo tanto, sus problemas posteriores al servicio no se pueden solucionar.¿Estás seguro de eliminarlo?",
          "status_success": "Completado",
          "status_pending": "No pagado",
          "status_cancel": "Cerrado",
          "status_unsub": "Cancelado",
          "payMethod_stripe": "Tarjeta de crédito"
        },
      },
      registerlogin: {
        create_account_tip:"Crea una cuenta, comienza la experiencia exclusiva",
        select_country_tip:"Uso de dispositivos país/región",
        email_name: "Correo",
        phone_name: "Teléfono",
        email_address: "Dirección de correo electrónico",
        password: "contraseña",
        country: "país",
        select_country: "Elige un país",
        cancel: "Cancelar",
        confirm: "Seguro",
        please_enter: "Ingrese 6-20 caracteres (combinación de letras, números o símbolos)",
        select_country_tips: "La selección de países es para ver paquetes locales. No se puede cambiar después del registro. ¡Confirme!",
        global_roaming: "Código de dominio internacional",
        phone_number: "número de teléfono",
        agree: "aceptar",
        user_agreement: "Acuerdo de usuario",
        and: "y",
        privacy_policy: "política de privacidad",
        register_login: "Regístrese o inicie sesión",
        login_error: "El número de inicios de sesión es demasiado frecuente, ¡inténtelo de nuevo más tarde!",
        register_error: "El número de registros es demasiado frecuente, ¡intente nuevamente más tarde!",
        forgot_pwd: "Olvida la contraseña",
        app_tips: "Inicie sesión en la aplicación con esta cuenta después de descargarla para acceder a más funciones.",
        download_app: "Ir a descargar la aplicación",
        rememberPwd: "Recuerda la contraseña",
        third_login: 'Continuar con',
        agreement_tips: "Por favor marque la casilla Acuerdo de usuario y Política de privacidad.",
        selectCountry_tips: "Tenga en cuenta que el país registrado afectará directamente los siguientes métodos de pago y monedas; seleccione según sus necesidades.",
        login_error_cancel: "El usuario canceló el inicio de sesión",
        login_error_auth: "Permite los pop-ups desde la configuración del navegador",
        device_tips: "Dispositivo pendiente de activación. Procesamos en 24h."
      },
      forgotPwd: {
        forgot_pwd: "Olvida la contraseña",
        email_address: "Dirección de correo electrónico",
        next: "Próximo",
        email_has_been_sent: "Hemos enviado un correo electrónico a %@email electrónico. Haga clic en el enlace y siga los pasos para recuperar su contraseña.",
        have_retrieved_it: "Lo he encontrado",
        unable_to_receive_email: "¿No puedes recibir el correo electrónico? Compruebe si hay correos electrónicos de %@email electrónico bajo su spam y directorio de correo eliminado",
        or: "o",
        resend: "Revender",
        global_roaming: "Código de dominio internacional",
        phone_number: "número de teléfono",
        verification_code_has_been_sent: "Hemos enviado el código de verificación a:",
        verification_code: "Código de verificación",
        no_verification_code_received: "¿No recibió el código de verificación?",
        please_enter: "Ingrese 6-20 caracteres (combinación de letras, números o símbolos)",
        reset_password: "Restablecer contraseña",
        reset_successful: "Reiniciar con éxito"
      },
      coupons: {
        coupons_name: "Cupones",
        no_coupons: "Todavía no hay cupones",
        no_data: "Aún no hay datos",
        applicable_to_the_following: "Los cupones son adecuados para el siguiente paquete de datos"
      },
      digital: {
        title: "Dispositivo SN",
        purchased: "Mis compras",
        viewAll: "Más",
        skinStore: "Tienda de productos",
        completed: "Comprado",
        goBuy: "Comprar",
        order: {
            title: "Pedidos comprados"
        },
        detail: {
            describe: "Descripción"
        }
      },
      viewPL: {
        other: 'otros'
      },
      invalidFlow: {
        stateName: "Estado",
        state: {
          NOT_ACTIVATED: "Inactivado",
          IN_USING: "Disponible",
          USE_END: "Exhausto",
          EXPIRE: "Venció",
          TRANSFER: "Transferir",
          UNSUBSCRIBE: "Cancelar",
          VALID: "Válido",
          INVALID: "Inválido",
          EXCHANGE_POINTS: "Canjear puntos"
        },
        noneFlow: "Ningún paquete de datos caducado",
        pageName: "Paquete de datos caducado"
      },
      flowDetail: {
        title: "Detalles de datos",
        flow: "Datos",
        validTime: "Detalles de datos",
        invalidTime: "Válido hasta",
        coverage: "Cobertura",
        useIntro: "Términos y condiciones",
        purchaseTime: "Comprado en",
        subtotal: "Subtotal",
        status: "Estado",
        cancel: "Cancelar",
        buyAgain: "Cómpralo de nuevo",
        validity: "Validez",
        tip: "Aviso",
        cancelTip: "¿Estás seguro de que deseas reembolsar este paquete?",
        dataLeft: "Datos restantes"
      },
      netError: {
        try_again: "Intentar otra vez",
        net_error: "No network",
        try_again_desc: "Por favor verifique la configuración de red e inténtelo nuevamente."
      },
      loadFail: {
        try_again: "Intentar otra vez",
        load_fail: "Error al cargar",
        load_fail_desc: "Error al cargar los datos, inténtalo de nuevo.",
        IMEI_Not_Exist: "IMEI no existe, intenta ingresar desde la entrada derecha",
        Project_Not_Exist: "Se produce un error. Por favor contacte con el servicio de atención al cliente.(01)",
        commonError: "Se produce un error. Póngase en contacto con el servicio de atención al cliente."
      },
      settlement_Easy_and_convenient: "Fácil y conveniente",
      settlement_Great_deal: "Gran parte",
      settlement_Safe_and_secure: "Seguro y seguro",
      settlement_Autopay_service_regulation: "Regulación de servicios automáticos",
      settlement_Read: "Leer",
      settlement_No_coupon: "No hay cupón disponible",
      settlement_Subtotal: "Subtotal",
      settlement_Coupon: "Cupón",
      settlement_TOTAL: "Total",
      settlement_promotion_tip: "La oferta promocional no se puede utilizar junto con cualquier cupones",
      settlement_coupon_tip: "El cupón no se puede usar junto con cualquier otra oferta promocional.",
      member_myFlow_noList: "No Data",
      detail_se_content: "Una forma segura, fácil y conveniente. Puedes dar a la suscripción en cualquier momento",
      Enter_Promo_code: "Código de promoción",
      Enter_Promo_Coupon:"Cupones",
      settlement_Not_used_coupon:"Cupón no utilizado",
      settlement_Available_coupon:"Disponible",
      settlement_Unavailable_coupon:"Indisponible",
      please_Enter_Promo_code: "Ingrese el código de promoción",
      please_Select_Coupon_use:　"Seleccione el cupón que desea usar.",
      Buy_Now: "Comprar ahora",
      Dont_Use_Any: "No uses ninguno",
      settlement_confirm: "Confirmar",
      flowDetail_unsubscribe: "Cancelar la suscripción",
      flowDetail_unsubscribed: "Sin suscripción",
      flowDetail_isCancelPackage: "¿Sumerezo de suscripción este paquete?",
      flowDetail_confirmAgreementUnsubscribe: "No puede tener lo mucho después de la suscripción. ¿Estás seguro de que quieres cancelar la suscripción?",
      flowDetail_cancel: "Cancelar",
      flowDetail_cancelSuccess: "Cancelar la suscripción con éxito",
      packages_detail_promotion: "Promoción",
      orderTips:{
        "iDay" : "día",
        "iDays" : "días",
        "iMonth" : "mes",
        "iMonths" : "meses",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol En tu primera compra, Pague %@money/%@periodSymbol más tarde, Puedes dar a la suscripción en cualquier momento",
        'Monthly_discount':"¡Ahorre %@saveMoney cada %@period! Puedes dar a la suscripción en cualquier momento ",
        'Ordinary_monthly_package':"Una forma segura, fácil y conveniente. Puedes dar a la suscripción en cualquier momento",
        "AlreadyPurchased":'Lamento que solo pueda suscribirse a un paquete de datos en este momento. Desempeñe la suscripción de “%@” y suscríbase más tarde a cualquier paquete que desee después de que expire.',
        "Contract_recommendation_First":'<label>Con el servicio automático, en su primera compra, solo pague</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">Puedes dar a la suscripción en cualquier momento'
        +'<a class="btn">Suscribir ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>Con servicio automático, paga solo</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Puedes dar a la suscripción en cualquier momento'
        +'<a class="btn">Suscribir ></a></p>',
        "Contract_recommendation_General":"<label>Con servicio automático</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Una forma segura, fácil y conveniente. Puedes dar a la suscripción en cualquier momento'
        +'<a href="javascript:;" class="btn">Suscribir ></a></p>',
        'BanlanceDoubleCheck':'¿Estás seguro de que quieres pagar con saldo?',
    },
    feedback: {
      title: "comentario",
      placeholder: "Ingrese el país que desea visitar o cualquier otra pregunta, ¡y satisfaremos sus necesidades lo antes posible!",
      submit: "Enviar",
      submit_success: "Enviado con éxito",
      other_opinions: "Otras opiniones",
    },
    view_country_input: 'Por favor ingresa tu cuenta',
    select_package: {
      title: 'Seleccionar Datos',
      allPackage: 'Todos los Datos',
      type: 'Tipo',
      flow: 'Datos',
      month_package: 'Plan Mensual',
      flow_package: 'Paquete Datos',
      time: 'Duración',
      period: 'Ciclo',
      auto_debit: 'Info Débito Automático',
      auto_subscribe: 'Auto-Renovación',
      detail: 'Detalles de Datos',
      carrier: 'Operadoras Compatible',
      country: 'Países Cubiertos',
      notice: 'Guía de Compra'
    },
}